module.exports = __webpack_public_path__ + "img/new_logo_revista.209f8ff0.svg";